<template>
    <Portal to="sidepanel">
        <SidePanel
            :key="`addPaymentMethodSidePanel-${String($.vnode.key)}`"
            class="add-payment-method"
            name="Add Card"
            width="medium"
            :disable-transition="disableTransition"
            :is-dark-mode="isDarkMode"
            :showCancelButton="false"
            :class="{ 'add-payment-method--full-height': showFullHeight }"
            @close="emitClose"
        >
            <PaymentFields
                mode="setup"
                class="add-payment-method__fields"
                @checkoutCompleted="checkoutCompleted"
            />
        </SidePanel>
    </Portal>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import UIKit from '@pocketprep/ui-kit'
import PaymentFields from '@/components/PaymentFields.vue'
import { stripeModule } from '@/store/stripe/module'
import { userModule } from '@/store/user/module'
import { toastModule } from '@/store/toast/module'

const {
    SidePanel,
} = UIKit

withDefaults(
    defineProps<{
        disableTransition?: boolean
        showFullHeight?: boolean
    }>(),
    {
        disableTransition: false,
        showFullHeight: false,
    }
)

const emit = defineEmits<{
    close: [value: boolean]
}>()

const isLoading = ref(false)

const isDarkMode = computed(() => {
    return userModule.state.settings.isDarkMode
})

const checkoutCompleted = async () => {
    isLoading.value = true
    if (import.meta.env.VUE_APP_STRIPE_PUBLISHABLE_KEY) {
        await stripeModule.actions.loadNewPaymentMethods()
        toastModule.actions.displayToast({
            title: 'Card added.',
        })
        emitClose()
    }
    isLoading.value = false
}

const emitClose = () => {
    emit('close', true)
}
</script>

<style lang="scss" scoped>
.add-payment-method {
    &--full-height {
        top: 0;
        height: 100%;
    }

    :deep(.uikit-side-panel__content) {
        padding: 26px 0;
    }
}
</style>
